module.exports = __webpack_public_path__ + "static/media/correcoes-1.e8bc0e58.png";